"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Autocomplete_1 = __importStar(require("@mui/material/Autocomplete"));
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var general_1 = require("utils/general");
var PREFIX = 'ComboBox';
var classes = {
    customSelectField: "".concat(PREFIX, "-customSelectField"),
    customInput: "".concat(PREFIX, "-customInput"),
};
var StyledTextField = (0, styles_1.styled)(material_1.TextField)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.customSelectField)] = function (_a) {
            var color = _a.color;
            return ({
                width: '100%',
                '& .MuiInput-underline': {
                    marginTop: theme.spacing(2),
                    '&:after': {
                        borderBottom: "1px solid ".concat(theme.palette[color].main),
                    },
                },
                '& .MuiSelect-icon': {
                    color: theme.palette[color].main,
                    fontSize: 32,
                },
            });
        },
        _b[".".concat(classes.customInput)] = {
            '& .MuiFormLabel-root': {
                color: theme.palette.grey[600],
                fontWeight: theme.typography.fontWeightLight,
                fontSize: '0.875rem',
            },
        },
        _b);
});
var ComboBox = function (_a) {
    var _b = _a.input, name = _b.name, onChange = _b.onChange, value = _b.value, restFormInputProps = __rest(_b, ["name", "onChange", "value"]), _c = _a.color, color = _c === void 0 ? 'primary' : _c, label = _a.label, options = _a.options, _d = _a.addOptions, addOptions = _d === void 0 ? true : _d, _e = _a.isSimple, isSimple = _e === void 0 ? true : _e, rest = __rest(_a, ["input", "color", "label", "options", "addOptions", "isSimple"]);
    var filter = (0, Autocomplete_1.createFilterOptions)();
    var filterOptions = function (opts, params) {
        var filtered = filter(opts, params);
        // Create a new value here, if addOptions is true
        if (addOptions && params.inputValue !== '') {
            filtered.push({ value: params.inputValue, label: "Add \"".concat(params.inputValue, "\"") });
        }
        return filtered;
    };
    var selectedOption = react_1.default.useMemo(function () { return isSimple ? { value: value, label: value } : options.find(function (opt) { return opt.value === value; }) || null; }, [value, options === null || options === void 0 ? void 0 : options.length]);
    return ((0, jsx_runtime_1.jsx)(Autocomplete_1.default, __assign({}, rest, { value: selectedOption, options: isSimple ? (0, general_1.makeValueLabelArray)(options) : options, filterOptions: filterOptions, getOptionLabel: function (option) { return option.label; }, isOptionEqualToValue: function (opt, selectedOpt) { return opt.value === selectedOpt.value; }, freeSolo: true, onChange: function (event, newValue) {
            if (typeof newValue === 'string') {
                onChange(newValue);
            }
            else if (newValue && newValue.value) {
                // Create a new value from input
                onChange(newValue.value);
            }
            else {
                onChange(newValue);
            }
        }, renderInput: function (inputProps) { return ((0, jsx_runtime_1.jsx)(StyledTextField, __assign({}, inputProps, restFormInputProps, { color: color, name: name, label: label, classes: { root: classes.customInput }, variant: "filled" }))); }, className: classes.customSelectField, color: color })));
};
exports.default = ComboBox;
